var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","min-height":"60vh"}},[(!_vm.error)?_c('p',[_vm._v("Iniciando sesión…")]):_c('div',[_c('p',[_vm._v("No fue posible iniciar sesión.")]),_c('button',{on:{"click":_vm.retry}},[_vm._v("Reintentar")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }